import { useSnackbar, VariantType, EnqueueSnackbar } from 'notistack';
import React from 'react';

interface IProps {
    setUseSnackbarRef: (showSnackbar: EnqueueSnackbar) => void;
}

const InnerSnackbarUtilsConfigurator: React.FC<IProps> = (props: IProps) => {
    const { enqueueSnackbar } = useSnackbar();
    props.setUseSnackbarRef(enqueueSnackbar);
    return null;
};

let useSnackbarRef: EnqueueSnackbar;
const setUseSnackbarRef = (useSnackbarRefProp: EnqueueSnackbar) => {
    useSnackbarRef = useSnackbarRefProp;
};

export const SnackbarUtilsConfigurator = () => {
    return (
        <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />
    );
};

export default {
    success(msg: string) {
        this.toast(msg, 'success');
    },
    warning(msg: string) {
        this.toast(msg, 'warning');
    },
    info(msg: string) {
        this.toast(msg, 'info');
    },
    error(msg: string) {
        this.toast(msg, 'error');
    },
    toast(msg: string, variant: VariantType = 'default') {
        if (useSnackbarRef) {
            useSnackbarRef(msg, { variant });
        } else {
            console.warn('SnackbarUtils not initialized. Message:', msg);
        }
    }
};
